import React from 'react'

export default function Right ({ className, fill }) {
  return (
    <svg fill={fill} className={className} xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'>
      <path d='M21 12l-18 12v-24z' />
    </svg>
  )
}

Right.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}
